// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"e5320da8","977":"fbb11d14"}[chunkId] + ".chunk.js";
};